/* TF · Colección · Looks — galería por tarjeta: hover-scrub (escritorio) + swipe (móvil).
 * Sin librerías. Usa solo las imágenes del producto ya presentes en el DOM. */
(function () {
  'use strict';
  if (window.__tfLookGal) return; window.__tfLookGal = true;

  function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 400); })(fn); }

  function preload(gal) {
    gal.__imgs.forEach(function (im) { if (im.getAttribute('loading') === 'lazy') im.setAttribute('loading', 'eager'); });
  }
  function setActive(gal, idx) {
    var imgs = gal.__imgs, n = imgs.length; if (!n) return;
    if (idx < 0) idx = 0; else if (idx > n - 1) idx = n - 1;
    if (gal.__cur === idx) return;
    imgs[gal.__cur].classList.remove('is-active');
    imgs[idx].classList.add('is-active');
    gal.__cur = idx;
  }

  function init(gal) {
    if (gal.__init) return; gal.__init = true;
    gal.__imgs = [].slice.call(gal.querySelectorAll('[data-tf-lookgal-img]'));
    if (gal.__imgs.length < 2) return;   // 1 imagen = comportamiento normal
    gal.__cur = 0;
    var card = gal.closest('a') || gal;

    // ---- Escritorio: recorrer imágenes según la posición horizontal del cursor ----
    gal.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') preload(gal); });
    gal.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = gal.getBoundingClientRect();
      setActive(gal, Math.floor((e.clientX - r.left) / r.width * gal.__imgs.length));
    });
    gal.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') setActive(gal, 0);   // al salir, vuelve a la principal
    });

    // ---- Móvil: swipe horizontal; conserva la última; sin bloquear el scroll vertical ----
    var sx = 0, sy = 0, base = 0, on = false, decided = false, horiz = false, moved = false;
    gal.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      preload(gal);
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; base = gal.__cur;
      on = true; decided = false; horiz = false; moved = false;
    }, { passive: true });
    gal.addEventListener('touchmove', function (e) {
      if (!on) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (!decided && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) { decided = true; horiz = Math.abs(dx) > Math.abs(dy); }
      if (decided && horiz) {
        if (e.cancelable) e.preventDefault();   // el gesto horizontal es nuestro
        moved = true;
        var span = gal.getBoundingClientRect().width / gal.__imgs.length;
        setActive(gal, base + Math.round(-dx / span));
      }
    }, { passive: false });
    gal.addEventListener('touchend', function () {
      if (on && moved) { gal.__block = true; setTimeout(function () { gal.__block = false; }, 500); }
      on = false;
    });

    // Un swipe no debe abrir el producto; un toque normal sí
    card.addEventListener('click', function (e) {
      if (gal.__block) { e.preventDefault(); e.stopPropagation(); gal.__block = false; }
    }, true);

    idle(function () { preload(gal); });   // precarga sin bloquear el primer render
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-tf-lookgal]'), init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
